/**
 * @generated SignedSource<<c0f1b9772d47abacaceb6991eed96217>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItemContent_issue$data = {
  readonly id: string;
  readonly resolved: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemAssignees_issue" | "WidgetIssueOverviewIssueItemImageThumbanil_issue" | "WidgetIssueOverviewIssueItemSectionTitle_issue" | "WidgetIssueOverviewIssueItemTitles_issue">;
  readonly " $fragmentType": "WidgetIssueOverviewIssueItemContent_issue";
};
export type WidgetIssueOverviewIssueItemContent_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItemContent_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemContent_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItemContent_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolved",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItemImageThumbanil_issue"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItemTitles_issue"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItemAssignees_issue"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItemSectionTitle_issue"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "4b133bef74182b7b1453e74d7cdb302d";

export default node;
